import React from "react";
import { Col } from "reactstrap";
import CurrencyFormat from "react-currency-format";
const PriceView = ({
  sellingPrice,
  discount,
  loading,
  trucktype,
  acceptOffer,
  disabled,
  showButton,
}) => {
  return (
    <Col
      lg={4}
      sm={12}
      className={
        "sellingPrice " +
        (sellingPrice ? "active" : "") +
        " " +
        (disabled ? "notactive" : "")
      }
    >
      <div className="fullquote">
        <div className="fullquote-days">
          <i className="mdi mdi-star orange"> </i>
          Driver, fuel, insurance, <b>VAT</b> included.
          {/* Driver, fuel, insurance and VAT included. */}
        </div>
        <img
          src={`https://media.qiktruck.co.za/3d-${trucktype}.png`}
          alt=""
          className={"menu-mini-truck-left "}
          height="20"
        />
        <div className="trucktype-left">
          {trucktype?.length < 20 ? trucktype : "please select a vehicle"}
        </div>
        {loading === false ? (
          <>
            {/* {sellingPrice > 0 && ( */}
            <>
              <CurrencyFormat
                value={sellingPrice / 100} //cents to rands
                displayType={"text"}
                thousandSeparator={true}
                prefix={"R"}
                decimalScale={2}
                className="sellingPriceValue"
              />
              {/* {sellingPrice > 0 && ( */}
              {showButton !== false && (
                <button
                  className="sell-nextbutton"
                  disabled={disabled}
                  onClick={() => acceptOffer()}
                >
                  Next
                </button>
              )}
              {/* )} */}
            </>
            {/* )} */}
          </>
        ) : (
          "calculating..."
        )}
      </div>
    </Col>
  );
};

export default PriceView;
